export default {
  getHasFilters(state) {
    const obj = state.filter || {};

    if (state.searchValue) {
      return true;
    }

    for (const key in obj) {
      const item = obj[key];
      const isArray = Array.isArray(item);
      if (isArray && item.length > 0) {
        return true;
      } else if (!isArray && item) {
        return true;
      }
    }

    return false;
  },
};
